<template>
    <v-expansion-panels accordion>
        <v-expansion-panel v-for="order in orders" :key="order.id">
            <v-expansion-panel-header>
                Заказ №{{ order.id }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout column>
                    <v-flex xs12 v-for="detail in order.details" :key="Math.random()">
                            <span>
                                {{ detail.product.name }}
                                <template v-if="detail.details.length" v-for="(item, index) in detail.details">
                                    ( <template v-if="index === 0">{{ item.attr }} </template>
                                    <template
                                        v-else-if="index === detail.details.length - 1"> {{ item.attr }}</template>
                                    <template v-else>{{ item.attr }}, </template> )
                                </template>
                                <template v-if="detail.variants.length" v-for="(item, index1) in detail.variants">
                                    ( <template v-if="index1 === 0">{{ item.label }} </template>
                                    <template
                                        v-else-if="index1 === detail.details.length - 1"> {{ item.label }}</template>
                                    <template v-else>{{ item.label }}, </template> )
                                </template>
                            </span>
                        <br/>
                        <span><b>Кол-во:</b> {{ detail.product_count }}</span>
                    </v-flex>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    export default {
        name: 'customerTelegramOrders',
        props: ['orders']
    }
</script>
